var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / success"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.9716 4 4 12.9716 4 24C4 35.0284 12.9716 44 24 44C35.0284 44 44 35.0284 44 24C44 12.9716 35.0284 4 24 4Z",
    fill: "#009262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1367 19.7631L23.3032 30.5962C22.9782 30.9212 22.5516 31.0848 22.125 31.0848C21.6983 31.0848 21.2717 30.9212 20.9467 30.5962L15.5301 25.1797C14.8783 24.5281 14.8783 23.4747 15.5301 22.8231C16.1817 22.1712 17.2348 22.1712 17.8867 22.8231L22.125 27.0614L31.7801 17.4065C32.4317 16.7547 33.4848 16.7547 34.1367 17.4065C34.7882 18.0581 34.7882 19.1112 34.1367 19.7631Z",
    fill: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPayment);
export default __webpack_public_path__ + "static/media/success-payment.57bbffde7393a685dc9abd0425446c2f.svg";
export { ForwardRef as ReactComponent };